import { apiPath } from '@/redux/apiPath';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkConfig } from '@/types/store';
import { getError } from '@/utils/error-report/getError';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { ModelElement, ModelElements } from '@/types/models';
import { MODEL_ELEMENTS_FETCHING_ERROR_PREFIX } from '@/redux/modelElements/modelElements.constants';
import { modelElementSchema } from '@/models/modelElementSchema';
import { pageableSchema } from '@/models/pageableSchema';

export const getModelElementsForModel = createAsyncThunk<
  Array<ModelElement> | undefined,
  number,
  ThunkConfig
>('modelElements/getModelElementsForModel', async (modelId: number) => {
  try {
    const { data } = await axiosInstanceNewAPI.get<ModelElements>(
      apiPath.getModelElements(modelId),
    );
    const isDataValid = validateDataUsingZodSchema(data, pageableSchema(modelElementSchema));
    return isDataValid ? data.content : undefined;
  } catch (error) {
    return Promise.reject(getError({ error, prefix: MODEL_ELEMENTS_FETCHING_ERROR_PREFIX }));
  }
});

export const updateElementGlyph = createAsyncThunk<
  null,
  {
    modelId: number;
    elementId: number;
    glyphId: number | null;
  },
  ThunkConfig
>('modelElements/updateElementGlyph', async ({ modelId, elementId, glyphId }) => {
  try {
    await axiosInstanceNewAPI.post(apiPath.updateElementGlyph(modelId, elementId), { id: glyphId });
    return null;
  } catch (error) {
    return Promise.reject(getError({ error }));
  }
});

export const updateElementSubmap = createAsyncThunk<
  null,
  {
    modelId: number;
    elementId: number;
    submapId: number | null;
  },
  ThunkConfig
>('modelElements/updateElementSubmap', async ({ modelId, elementId, submapId }) => {
  try {
    await axiosInstanceNewAPI.post(apiPath.updateElementSubmap(modelId, elementId), {
      id: submapId,
    });
    return null;
  } catch (error) {
    return Promise.reject(getError({ error }));
  }
});
